// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SavedAddressEditor__wrapper___1yFFB","close":"SavedAddressEditor__close___3RJ89"};